import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { GridIcon, IconLocation } from '../types';
import { NetworkGridIconHelper } from './network.grid.icon.helper';
import { ButtonColor } from '../../../../ui/gzIconButton/types';
import { IconProperties } from '../../../../ui/gzIcon/types';
import { NetworkTreeIconHelper } from './networkTreeIconHelper';

export class NetworkIconHelper {
  public static getIconForProtectedEntity(
    protectedEntity: ProtectedEntity,
    iconLocation: IconLocation
  ): IconProperties {
    switch (iconLocation) {
      case IconLocation.GRID:
        return NetworkGridIconHelper.getIconForProtectedEntity(protectedEntity);
      case IconLocation.TREE:
        return NetworkTreeIconHelper.getIconForProtectedEntity(protectedEntity);
      default:
        return {
          icon: GridIcon.ICON_RESOURCE_GENERIC,
          color: ButtonColor.PRIMARY,
        };
    }
  }
}
